import { apiRequest } from '../../api-client';

export interface ZendeskTicket {
  id: number;
  subject: string;
  description: string;
  requester_id: number;
  status: string;
  custom_fields: { id: number; value: string | null }[];
}

/**
 * Look up a Zendesk ticket by ID.
 * GET /api-internal/zendesk/tickets/:ticket_id
 */
export function lookupZendeskTicket({
  token,
  ticketId
}: {
  token: string;
  ticketId: string;
}): Promise<ZendeskTicket> {
  return apiRequest({
    method: 'GET',
    endpoint: `/api-internal/zendesk/tickets/${ticketId}`,
    token
  });
}
